import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import '../HolidayOffer/HolidayOffer.css'
const sliderData = [
    {
      id: 1,
      image: "sh1.jpg", 
      title: "Grand Palace Hotel",
      description: "Enjoy a luxurious stay with 40% off on premium suites. Limited time offer!",
    },
    {
      id: 2,
      image: "sh2.jpg",
      title: "Ocean View Resort",
      description: "Book now and get complimentary breakfast with your stay. Special discounts available!",
    },
    {
      id: 3,
      image: "sh3.jpg",
      title: "Mountain Retreat Lodge",
      description: "Escape to the hills with a 30% discount on all weekend bookings!",
    },
  ];
  
  const offers = [
    {
      image: "sofitel.jpg",
      country: "Dubai",
      hotel: "Sofitel, The Palm",
      rating: 5,
      offer: "FREE Upgrade to Half Board",
      price: "5 Nights from \u00a31052 pp (Inc. flights)",
      board: "Half Board",
      date: "4th May 2025 - 3rd Oct 2025"
    },
    {
      image: "vdara.jpg",
      country: "Las Vegas",
      hotel: "Vdara Hotel & Spa",
      rating: 5,
      offer: "Upgrade to Fountain View Studio from extra \u00a399pp",
      price: "4 Nights from \u00a3894 pp (Inc. flights)",
      board: "Room Only",
      date: "1st Jun 2025 - 31st Jul 2025"
    },
    {
      image: "portofino.jpg",
      country: "Orlando",
      hotel: "Loews Portofino Bay Hotel",
      rating: 5,
      offer: "Upgrade to Bay View from extra \u00a3149pp",
      price: "7 Nights from \u00a31483 pp (Inc. flights)",
      board: "Half Board",
      date: "1st Sep 2025 - 31st Oct 2025"
    },
    {
      image: "oneonly.jpg",
      country: "Mauritius",
      hotel: "One&Only Le Saint Geran",
      rating: 5,
      offer: "FREE Upgrade to Half Board!",
      price: "7 Nights from \u00a32853 pp (Inc. flights)",
      board: "Half Board",
      date: "13th May 2025 - 30th Jun 2025"
    }
  ];
  
const HolidayOffer = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1));
    };
  
    const nextSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex === sliderData.length - 1 ? 0 : prevIndex + 1));
    };
  
    useEffect(() => {
      const interval = setInterval(() => {
        nextSlide();
      }, 3000);
      return () => clearInterval(interval);
    }, [currentIndex]);
  
  return (
    <>
         <div className="slider-offer-container-h">
      <div className="slider-h">
        {sliderData.map((slide, index) => (
          <div
            key={slide.id}
            className={index === currentIndex ? "slide-h active" : "slide-h"}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="overlay-h">
              <h1>{slide.title}</h1>
              <p>{slide.description}</p>
              <a href="#" className="view-more-h">View More</a>
            </div>
          </div>
        ))}
        <button className="prev-h" onClick={prevSlide}><FaChevronLeft /></button>
        <button className="next-h" onClick={nextSlide}><FaChevronRight /></button>
      </div>
    </div>


    <div className="offer-input">
      <div className="dropdown-container">
        <label>Where to?</label>
        <select className="dropdown">
          <option>All Destinations</option>
          <option>Abu Dhabi</option>
          <option>Dubai</option>
          <option>Paris</option>
          <option>London</option>
        </select>
      </div>
      <div className="dropdown-container">
        <label>Duration</label>
        <select className="dropdown">
          <option>All Night</option>
          <option>0-7 Nights</option>
          <option>7-14 Nights</option>
        </select>
      </div>
      <div className="dropdown-container">
        <label>Rating</label>
        <select className="dropdown">
          <option>1 Star</option>
          <option>2 Star</option>
          <option>3 Star</option>
          <option>4 Star</option>
          <option>5 Star</option>
        </select>
      </div>
      <div className="dropdown-container">
        <label>Board</label>
        <select className="dropdown">
          <option>All Boards</option>
          <option>All Exclusive</option>
          <option>Bed and Breakfast</option>
          <option>Full Board</option>
          <option>Half Board</option>
          <option>Room Only</option>
        </select>
      </div>
      <div className="dropdown-container">
        <label>Price</label>
        <select className="dropdown">
          <option>€0-1000</option>
          <option>€1000-2000</option>
          <option>€2000-3000</option>
        </select>
      </div>
      <div className="dropdown-container">
        <label>Sort By</label>
        <select className="dropdown">
          <option>No. of Hotels</option>
          <option>Price</option>
          <option>Hotel Rating</option>
          <option>Name</option>
        </select>
      </div>
    </div>




    <div className="offer-section">
      <div className="offer-left">
        <h2>Holiday Offers</h2>
        <p>
          Your next luxury holiday is not as far away as you may think. From boutique hotels to all-inclusive resorts, we bring you the best deals.
        </p>
        <p>
          Take a look at our special offers or call us on <a href="tel:0203966468">020 3966 4668</a> for more information.
        </p>
        <p className="note">*All holiday offers include economy flights as standard</p>
      </div>
      <div className="offer-right">
        {offers.slice(0, 2).map((item, index) => (
          <div className="offer-card" key={index}>
            <img src={item.image} alt={item.hotel} className="offer-image" />
            <p className="country">{item.country}</p>
            <h3 className="hotel-name">{item.hotel}</h3>
            <div className="stars">{"\u2605".repeat(item.rating)}</div>
            <div className="offer-box">{item.offer}</div>
            <p className="price">{item.price}</p>
            <strong className="board-category">{item.board}</strong>
            <p className="date">Available: {item.date}</p>
          </div>
        ))}
      </div>
      <div className="offer-grid">
        {offers.slice(2).map((item, index) => (
          <div className="offer-card" key={index}>
            <img src={item.image} alt={item.hotel} className="offer-image" />
            <p className="country">{item.country}</p>
            <h3 className="hotel-name">{item.hotel}</h3>
            <div className="stars">{"\u2605".repeat(item.rating)}</div>
            <div className="offer-box">{item.offer}</div>
            <p className="price">{item.price}</p>
            <strong className="board-category">{item.board}</strong>
            <p className="date">Available: {item.date}</p>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default HolidayOffer